import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import AuthShell from '../components/AuthShell';
import { Mail, Lock } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('E-posta ve şifre zorunlu'); return; }
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Hoş geldin ${user.name}!`);
      navigate(location.state?.from || '/dashboard');
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Giriş Yap"
      subtitle="Premium indirme paneline güvenli giriş yap."
      footer={<p className="text-center text-sm text-muted-foreground mt-6">Hesabın yok mu? <Link to="/register" className="text-fuchsia-300 hover:text-white">Üye ol</Link> · <Link to="/forgot-password" className="hover:text-white">Şifremi unuttum</Link></p>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-1.5">
          <Label htmlFor="email">E-posta</Label>
          <div className="relative auth-input-wrap">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input id="email" type="email" placeholder="ornek@mail.com" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9 auth-input" data-testid="login-email-input" required />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password">Şifre</Label>
          <div className="relative auth-input-wrap">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input id="password" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-9 auth-input" data-testid="login-password-input" required />
          </div>
        </div>
        <Button type="submit" disabled={loading} className="w-full premium-cta" data-testid="login-submit-btn">
          {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </Button>
      </form>
    </AuthShell>
  );
}
